export var PLAN_DEFAULT_PAGE = 1;
export var PLAN_LIST_LIMIT = 100;
export var PLAN_OPTIONS_LIMIT = 100;
export var DEFAULT_PLAN_PROJECT_ID = "f52f2599-aba1-4fa9-be8a-4f71c7a1d33a";
export var PLAN_DELETE_ENTITY = "PlanEntity";
export var PLAN_CARD_CURRENCY = "$";
export var PLAN_CARD_PERIOD = "Mes";
export var PLAN_CARD_PRICE = "0";
export var FILTER_SPONSOR_NAME = "Sponsor";
export var FILTER_TYPE_NAME = "Tipo";
export var FILTER_RULES_NAME = "Reglas";
export var FILTER_TYPE_LABEL = "label";
export var OPTION_ID_EDIT = "1";
export var OPTION_ID_DELETE = "2";
export var LOADING_TEXT = "Cargando...";
export var DELETING_TEXT = "Eliminando...";
export var TOAST_DELETE_SUCCESS = "Eliminado con éxito";
export var FORM_TITLE = "Agregar Plan";
export var FORM_SUBTITLE = "Beneficiario";
export var FORM_PERCENTAGE_LABEL = "Porcentaje a beneficiar";
export var MODAL_DELETE_TITLE = "Eliminar";
export var modalDeleteQuestion = function (title) {
    return "\u00BFEst\u00E1 seguro que desea Eliminar ".concat(title !== null && title !== void 0 ? title : "", "?");
};
export var MODAL_DELETE_CANCEL_LABEL = "No";
export var MODAL_DELETE_CONFIRM_LABEL = "Si, eliminar";
